import BaseDialog from './../../../zzl-vue-component/BaseDialog'
import TagList from './../../js-api/TagList'

export default {
	name: 'TagSelectDialog',
	props: {
		value: {
			type: Array
		},
		slugs: {
			type: [Array, null],
			default: null
		},
		excludes: {
			type: [Array, null],
			default: null
		}
	},
	data() {
		return {
			items: [],
		}
	},
	components: {
		BaseDialog,
	},
	template: `
		<BaseDialog class="page-select"
			title="タグ"
		>
			<span class="page-tag page-tag-clickable"
				:class="{ selected: item.selected }"
				v-for="(item, i) in items"
				@click="toggle(i)"
			>
				{{item.name}}
			</span>

			<template v-slot:buttons>
				<button type="button" class="bs-ed-btn bs-ed-btn-primary"
					@click="commit"
				>
					OK
				</button>
				<button type="button" class="bs-ed-btn bs-ed-btn-default"
					@click="$emit('cancel')"
				>
					キャンセル
				</button>
			</template>
		</BaseDialog>
	`,
	mounted() {
		TagList.get().then(items => {
			this.items = items
			.filter(item => this.slugs == null || this.slugs.some(slug => slug === item.slug))
			.filter(item => this.excludes == null || !this.excludes.some(slug => slug === item.slug))
			.map(item => {
				return {
					id: item.id,
					name: item.name,
					selected: this.value.some(val => val === item.id),
				}
			})
		})
	},
	methods: {
		toggle(index) {
			this.items[index].selected = !this.items[index].selected
		},
		commit(item) {
			const tagIds = this.items.filter(item => item.selected).map(item => item.id)
			this.$emit('input', tagIds)
		}
	},
}
